import { Injectable } from '@angular/core';
import { AblyChannelData } from '@models/ably';
import { Types } from 'ably/ably';
import * as Ably from 'ably/promises';

export type AblyChannel = Types.RealtimeChannelPromise;

@Injectable({
  providedIn: 'root'
})
export class AblyChannelsService {
  get(data: AblyChannelData) {
    const { channel, ...clientOptions } = data;
    const realtime = new Ably.Realtime(clientOptions);
    return realtime.channels.get(channel);
  }
}
